import { wasteVolumeColumns } from "../columns";
import { WithTitle } from "../shared";

import { CustomTable } from "@/components/reusables/data-table/CustomTable";
import { ExtendedColumnDef } from "@/interfaces/globals";

type TProps = { wasteVolume: object };

const WasteVolume: React.FC<TProps> = ({ wasteVolume }) => {
  const finalData = Array.from(Object.entries(wasteVolume)).map(
    (data, index) => ({
      id: `item-${index}`,
      loadType: data[0],
      quantity: data[1],
    }),
  );

  return (
    <WithTitle title='Waste Volume' className='h-full max-w-full min-w-0 p-4'>
      <CustomTable
        title='Waste Volume'
        empty={{
          subtitle: "add some data to show here",
          small: true,
        }}
        columns={wasteVolumeColumns as ExtendedColumnDef<object>[]}
        data={finalData}
        filters={false}
        id='waste-volume'
        hide={{
          filters: true,
          functions: true,
        }}
      />
    </WithTitle>
  );
};

export default WasteVolume;
